import { render, staticRenderFns } from "./DocumentSeriesTypeList.vue?vue&type=template&id=7b394076&"
import script from "./DocumentSeriesTypeList.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports